import styled from 'styled-components/native';

export const ContentRow = styled.View`
  flex: 1;
  flex-direction: row;
`;
